export const TIMEREGISTRATIONLIST_SEARCH = 'TIMEREGISTRATIONLIST_SEARCH';
export const TIMEREGISTRATIONLIST_PAGE = 'TIMEREGISTRATIONLIST_PAGE';
export const TIMEREGISTRATIONLIST_USER = 'TIMEREGISTRATIONLIST_USER';
export const TIMEREGISTRATIONLIST_WEEK = 'TIMEREGISTRATIONLIST_WEEK';
export const TIMEREGISTRATIONLIST_YEAR = 'TIMEREGISTRATIONLIST_YEAR';